import axios from './_nestAxios'

export const getAsTreeView = () => axios.get('/estructurasDeBalance', { params: { tipoConsulta: 'tree-view' } })

export const nuevoCorrelativo = id => axios.get('/estructurasDeBalance/nuevo-correlativo', { params: id })

export const nuevaEstructura = data => axios.post('/estructurasDeBalance/', data)

export const getEstructuraBalance = _id => axios.get(`/estructurasDeBalance/${_id}`)

export const eliminarEstructuraBalance = _id => axios.delete(`/estructurasDeBalance/${_id}`)

export const editarEstructura = data => axios.put('/estructurasDeBalance/', data)
